import { Platform } from "react-native";
import { ROUTE } from "../../routes";
import { api, StoreKey } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import { InputStateToken } from "@voltmoney/schema";
import sharedPropsService from "../../SharedPropsService";
let phone = '';
let pan = '';
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const onChangeInput = async (action, _datastore, { navigateWithClear, network, asyncStorage, setDatastore, navigate }) => {
    console.warn("**** onChangeInput Action Triggered ****", action);
    const otp = action.payload.value;
    const verifyOtpData = await sharedPropsService.getMfCentralInitResponse();
    const leadId = action.payload.leadId;
    const isResend = action.payload.isResend;
    if (otp?.length === 6) {
        await setDatastore(action.routeId, 'otpModalScreen', {
            state: InputStateToken.LOADING
        });
        const mfCentralVerifyOtpRequestBody = {
            reqId: verifyOtpData?.reqId,
            otpRef: verifyOtpData?.otpRef,
            otp: otp,
            leadId: leadId,
            clientRefNo: verifyOtpData?.clientRefNo
        };
        // verify Otp call
        // const header = await getAppHeader();
        // header['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.PLATFORM_AUTH_TOKEN)}`;
        const mfCentralVerifyOtpResponse = await network.post(`${api.MFCentralVerifyOtpV2}`, mfCentralVerifyOtpRequestBody, {
            headers: await getAuthHeaders()
        }, async () => { return; }, {
            isPartnerPlatform: true
        });
        console.log("mfCentralVerifyOtpResponse: ", mfCentralVerifyOtpResponse);
        if (mfCentralVerifyOtpResponse?.status === 200) {
            await asyncStorage.set(StoreKey.LEAD_TOKEN, mfCentralVerifyOtpResponse?.data?.jwt);
            await setDatastore(action.routeId, 'otpModalScreen', {
                state: InputStateToken.SUCCESS
            });
            await navigateWithClear(ROUTE.CHECK_LIMIT_LOADING, { leadId: leadId });
        }
        else if (mfCentralVerifyOtpResponse?.response?.status === 400) {
            console.log("here otp: ", mfCentralVerifyOtpResponse?.response?.data?.voltErrorCode);
            await setDatastore(action.routeId, 'otpModalScreen', {
                state: InputStateToken.ERROR,
                caption: {
                    error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
                }
            });
            if (mfCentralVerifyOtpResponse?.response?.data?.voltErrorCode == 'MF_OTP_ATTEMPTS_EXHAUSTED') {
                console.log("here: otp");
                await setDatastore(action.routeId, 'otpModalScreen', {
                    state: InputStateToken.DISABLED,
                    otpLimitExceeded: true,
                });
            }
            // await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL)
        }
        else if (mfCentralVerifyOtpResponse?.response?.status === 500) {
            await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            await setDatastore(action.routeId, 'otpModalScreen', {
                state: InputStateToken.ERROR,
                caption: {
                    error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
                }
            });
        }
        else {
            await setDatastore(action.routeId, 'otpModalScreen', {
                state: InputStateToken.ERROR,
                caption: {
                    error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
                }
            });
        }
    }
};
export const onGoBack = async (action, _datastore, { navigateWithClear }) => {
    console.warn("**** onGoBack Action Triggered ****", action);
    await navigateWithClear(ROUTE.CHECK_LIMIT_MFC_INIT);
};
